import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-738e0e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_2 = { class: "p-24 grid content-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`my-4 w-2/5 text-secondary`)
}
const _hoisted_5 = {
  class: "container lg:px-8 xl:px-0 pt-10",
  style: {"max-width":"1280px"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center mb-12"
}
const _hoisted_7 = { class: "py-4 text-3xl font-bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass(`pt-10 grid -gap-8 grid-cols-3`)
}
const _hoisted_12 = { class: "text-2xl font-bold" }
const _hoisted_13 = { class: "pt-4 text-base text-gray-600" }
const _hoisted_14 = {
  key: 0,
  class: "flex justify-center pt-10"
}
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = {
  key: 0,
  class: "card-icon flex justify-center -mt-12"
}
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "px-1" }
const _hoisted_19 = { class: "card-name text-center text-xl" }
const _hoisted_20 = { class: "card-summary pt-6 file:text-sm text-secondary" }
const _hoisted_21 = {
  class: "w-full flex justify-center",
  id: "join-now"
}
const _hoisted_22 = {
  class: "container lg:px-8 xl:px-0 pt-10",
  style: {"max-width":"1280px"}
}
const _hoisted_23 = { class: "flex flex-col items-center mb-12" }
const _hoisted_24 = { class: "py-4 text-3xl font-bold" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_26 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_27 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_28 = { class: "row items-center justify-end" }
const _hoisted_29 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_30 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_31 = { class: "my-4 text-xl" }
const _hoisted_32 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_33 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_34 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_35 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_36 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_37 = { class: "my-4 text-xl" }
const _hoisted_38 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_39 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_40 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_41 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_43 = { class: "my-4 text-xl" }
const _hoisted_44 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_45 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_46 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_47 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_48 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_49 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_50 = { class: "my-4 text-xl" }
const _hoisted_51 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_52 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_53 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_54 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_55 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_56 = { class: "grid grid-cols-1 gap-x-24" }
const _hoisted_57 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_58 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_59 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_60 = { class: "grid grid-cols-2 gap-x-24" }
const _hoisted_61 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_62 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_63 = { class: "row items-center justify-end" }
const _hoisted_64 = { class: "w-36 mr-4 text-sm flex justify-between" }
const _hoisted_65 = { class: "col-span-2 flex justify-center" }

import { ref, computed } from 'vue';
import { create } from 'src/api/JoinUs';
// import {
//   isValid,
//   sendSmsSecurityCode,
//   vertifySmsSecurityCode,
// } from 'src/utils/sms';
import { Notify } from 'quasar';
import { useMeta } from 'quasar';
import type { QPopupProxy } from 'quasar'
import { useMetaStore } from 'src/stores/modules/meta';
import { useI18n } from 'vue-i18n';


import { reactive } from 'vue';
import { usePageStore } from 'stores/modules/page';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ url: currentRoute.path });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'JoinUsPage',
  setup(__props) {

const { t, locale } = useI18n();
const pageStore = usePageStore();
const page = computed(() => pageStore.page);

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);
const registrationPicker = ref<QPopupProxy | null>(null)
const expectedClosingPicker = ref<QPopupProxy | null>(null)

const openRegistrationDate = () => {
  registrationPicker.value?.show()
}
const openExpectedClosingDate = () => {
  expectedClosingPicker.value?.show()
}

const formatDate = (date) => {
  if (!date) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const formRef = ref();

const model = reactive({
  company: '',
  address: '',
  summary: '',
  direction: '',
  name: '',
  job: '',
  phone: '',
  email: '',
  securityCode: '',
  registrationDate: formatDate(new Date()),
  resellerName: '',
  saleName: '',
  saleContact: '',
  saleEmail: '',
  presaleName: '',
  presaleContact: '',
  presaleEmail: '',
  buyerName: '',
  buyerRole: '',
  buyerContact: '',
  buyerEmail: '',
  championName: '',
  championRole: '',
  championContact: '',
  championEmail: '',
  opportunitySummary: '',
  opportunityDetails: '',
  competitorSolutions: '',
  estimatedProjectVal: '',
  expectedClosingDate: '',
  projectInitiatedBy: ''
});

const state = reactive({
  loading: false,
  vertifying: t('JoinUs.vertifying'),
});

// let timeout: NodeJS.Timeout;

// const clearVertifyingTimeout = () => {
//   state.vertifying = t('JoinUs.vertifying');
//   clearInterval(timeout);
// };

// const setVertifyingTimeout = () => {
//   clearInterval(timeout);
//   state.vertifying = `${t('JoinUs.vertifying')}(60s)`;
//   let seconds = 59;
//   timeout = setInterval(() => {
//     state.vertifying = `${t('JoinUs.vertifying')}(${seconds}s)`;
//     seconds--;
//     if (seconds < 0) {
//       clearVertifyingTimeout();
//     }
//   }, 1000);
// };

// const handleSendVertifyCode = async () => {
//   if (state.vertifying !== t('JoinUs.vertifying')) return;
//   if (!isValid(model.phone)) {
//     Notify.create({
//       message: t('JoinUs.securityCode.message'),
//       type: 'warning',
//     });
//     return;
//   }
//   setVertifyingTimeout();

//   await sendSmsSecurityCode(model.phone);
//   model.securityCode = '';
// };

const handleSubmit = async () => {
  state.loading = true;
  try {
    // await vertifySmsSecurityCode(model.phone, model.securityCode);
    await create({
      ...model,
    });
    formRef.value?.reset();
    Notify.create(t('JoinUs.notify'));
    // clearVertifyingTimeout();
  } finally {
    state.loading = false;
  }
};

const handleReset = () => {
  model.company = '';
  model.address = '';
  model.summary = '';
  model.direction = '';
  model.name = '';
  model.job = '';
  model.phone = '';
  model.email = '';
  model.securityCode = '';
};

const background = (
  image: string,
  size = 'cover',
  position = 'center center'
) => {
  return image
    ? `background: url('${image}') no-repeat; background-size: ${size}; background-position: ${position}`
    : '';
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.regions, (region) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: region.id
        }, [
          (region.type === 'summary')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "header w-full flex justify-center",
                style: _normalizeStyle(background(region.image))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`text-2xl ${
                region.extraProperties?.theme === 'dark' ? 'text-white' : ''
              }`),
                      innerHTML: region.name
                    }, null, 10, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((region.summary ?? '').split('\n'), (p, i) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: i,
                          class: "text-justify"
                        }, _toDisplayString(p), 1))
                      }), 128))
                    ]),
                    (region.url)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          class: "w-40 h-11",
                          "no-caps": "",
                          padding: "0",
                          color: "linear-color2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(region.content || _unref(t)('Product.consult')), 1)
                          ]),
                          _: 2
                        }, 1024)), [
                          [_directive_scroll_to, '#join-now']
                        ])
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "w-full flex justify-center",
                style: _normalizeStyle(`${background(
          region.image,
          'cover',
          'bottom center;padding-top:60px;padding-bottom:170px;'
        )}`)
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (region.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(region.name), 1),
                        _hoisted_8
                      ]))
                    : _createCommentVNode("", true),
                  (region.type === 'document')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(`ql-editor ${_unref(locale)?.split('-')[0]}`),
                        innerHTML: region.content
                      }, null, 10, _hoisted_9))
                    : _createCommentVNode("", true),
                  (region.type === 'image-list')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child, i) => {
                          return (_openBlock(), _createBlock(_component_q_img, {
                            key: i,
                            src: child.image,
                            alt: child.name
                          }, null, 8, ["src", "alt"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (
              region.type === 'data-list' &&
              region.children?.length &&
              region.name == 'Cooperation strategy' || region.extraProperties.theme == '合作战略'
            )
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: child.id
                          }, [
                            _createVNode(_component_q_card, { class: "h-full bg-card !bg-transparent" }, {
                              default: _withCtx(() => [
                                (child.image)
                                  ? (_openBlock(), _createBlock(_component_q_img, {
                                      key: 0,
                                      src: child.image,
                                      alt: child.name,
                                      loading: "lazy"
                                    }, {
                                      loading: _withCtx(() => [
                                        _createVNode(_component_q_spinner_dots, {
                                          color: "primary",
                                          size: "1.5rem"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["src", "alt"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_q_card_section, { class: "p-10 text-center" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(child.name), 1),
                                    _createElementVNode("div", _hoisted_13, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                        return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                      }), 128))
                                    ]),
                                    (child.icon)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                          _createElementVNode("img", {
                                            class: "w-20 h-20",
                                            src: child.icon,
                                            alt: child.icon
                                          }, null, 8, _hoisted_15)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default').includes('悬浮卡片')
            )
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 4,
                        class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${region.children.length}`)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: child.id
                          }, [
                            _createVNode(_component_q_card, {
                              class: _normalizeClass(`h-full p-4 rounded-2xl !bg-transparent opacity-75 hvr-float  ${
                  child.image ? '' : 'bg-card'
                } ${
                  (region.extraProperties?.theme ?? 'default').includes('反色')
                    ? 'reverse'
                    : ''
                }`)
                            }, {
                              default: _withCtx(() => [
                                (child.icon)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createElementVNode("img", {
                                        class: "w-16 h-16",
                                        src: child.icon,
                                        alt: child.icon
                                      }, null, 8, _hoisted_17)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_q_card_section, { class: "py-4" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, _toDisplayString(child.name), 1),
                                      _createElementVNode("div", _hoisted_20, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                        }), 128))
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ], 4))
        ], 64))
      }), 128)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('JoinUs.join')), 1),
            _hoisted_25
          ]),
          _createVNode(_component_q_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: handleSubmit,
            onReset: handleReset
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_q_input, {
                  modelValue: model.registrationDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.registrationDate) = $event)),
                  placeholder: _unref(t)('JoinUs.select'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: "",
                  onClick: openRegistrationDate
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('JoinUs.registrationDate')), 1)
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "mdi-calendar",
                      class: "cursor-pointer"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_popup_proxy, {
                          ref_key: "registrationPicker",
                          ref: registrationPicker,
                          cover: "",
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_date, {
                              modelValue: model.registrationDate,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.registrationDate) = $event)),
                              mask: "YYYY-MM-DD"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_28, [
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    label: "Close",
                                    color: "primary",
                                    flat: ""
                                  }, null, 512), [
                                    [_directive_close_popup, true]
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.resellerName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.resellerName) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.resellerName')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('JoinUs.saleTitle')), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_q_input, {
                  modelValue: model.saleName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.saleName) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.saleName')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.saleContact,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.saleContact) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.saleContact')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.saleEmail,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model.saleEmail) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.saleEmail')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('JoinUs.presaleTitle')), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_q_input, {
                  modelValue: model.presaleName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((model.presaleName) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.presaleName')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.presaleContact,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((model.presaleContact) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.presaleContact')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.presaleEmail,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((model.presaleEmail) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.presaleEmail')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('JoinUs.buyerTitle')), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_q_input, {
                  modelValue: model.buyerName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((model.buyerName) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.buyerName')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.buyerRole,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((model.buyerRole) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.buyerRole')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.buyerContact,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((model.buyerContact) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.buyerContact')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.buyerEmail,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((model.buyerEmail) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.buyerEmail')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('JoinUs.championTitle')), 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_q_input, {
                  modelValue: model.championName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((model.championName) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.championName')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.championRole,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((model.championRole) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.championRole')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.championContact,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((model.championContact) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.championContact')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.championEmail,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((model.championEmail) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.championEmail')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_q_input, {
                  modelValue: model.opportunitySummary,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((model.opportunitySummary) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  type: "textarea",
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.opportunitySummary')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.opportunityDetails,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((model.opportunityDetails) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  type: "textarea",
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.opportunityDetails')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.competitorSolutions,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((model.competitorSolutions) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  type: "textarea",
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.competitorSolutions')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_q_input, {
                  modelValue: model.estimatedProjectVal,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((model.estimatedProjectVal) = $event)),
                  placeholder: _unref(t)('JoinUs.enter'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.estimatedProjectVal')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.expectedClosingDate,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((model.expectedClosingDate) = $event)),
                  placeholder: _unref(t)('JoinUs.select'),
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: "",
                  onClick: openExpectedClosingDate
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.expectedClosingDate')), 1)
                    ])
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "mdi-calendar",
                      class: "cursor-pointer"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_popup_proxy, {
                          ref_key: "expectedClosingPicker",
                          ref: expectedClosingPicker,
                          cover: "",
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_date, {
                              modelValue: model.expectedClosingDate,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((model.expectedClosingDate) = $event)),
                              mask: "YYYY-MM-DD"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_63, [
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    label: "Close",
                                    color: "primary",
                                    flat: ""
                                  }, null, 512), [
                                    [_directive_close_popup, true]
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "rules"]),
                _createVNode(_component_q_input, {
                  modelValue: model.projectInitiatedBy,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((model.projectInitiatedBy) = $event)),
                  placeholder: "Please enter Reseller / Customer)",
                  rules: [(val) => val && val.length > 0],
                  outlined: "",
                  dense: ""
                }, {
                  before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('JoinUs.projectInitiatedBy')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_q_btn, {
                  class: "w-1/2 mt-4 text-base text-white horizontal-gradient rounded-lg",
                  type: "submit",
                  flat: "",
                  "no-caps": "",
                  loading: state.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('JoinUs.submit')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})